import React from 'react';
import { CalendarMonth } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

interface ReportDateRangeFilterProps {
    fromDate: string;
    toDate: string;
    onFromDateChange: (value: string) => void;
    onToDateChange: (value: string) => void;
    /** @deprecated Styling is now handled internally to match the GIG report. */
    fromLabelClassName?: string;
    /** @deprecated Styling is now handled internally to match the GIG report. */
    toLabelClassName?: string;
}

// Matches the .formLabel styling used on the GIG / KPI report date filters.
const labelSx = {
    fontFamily: 'var(--font-body)',
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
} as const;

const ReportDateRangeFilter: React.FC<ReportDateRangeFilterProps> = ({
    fromDate,
    toDate,
    onFromDateChange,
    onToDateChange,
}) => {
    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Stack spacing={0.5} className="form-group">
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <CalendarMonth sx={{ fontSize: 15, color: 'gray' }} />
                    <Typography component="label" htmlFor="report-start-date" sx={labelSx}>
                        Start Date
                    </Typography>
                </Stack>
                <input
                    id="report-start-date"
                    type="date"
                    value={fromDate}
                    max={toDate}
                    onChange={(e) => onFromDateChange(e.target.value)}
                    style={{ width: '100%' }}
                />
            </Stack>
            <Stack spacing={0.5} className="form-group">
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <CalendarMonth sx={{ fontSize: 15, color: 'gray' }} />
                    <Typography component="label" htmlFor="report-end-date" sx={labelSx}>
                        End Date
                    </Typography>
                </Stack>
                <input
                    id="report-end-date"
                    type="date"
                    value={toDate}
                    min={fromDate}
                    onChange={(e) => onToDateChange(e.target.value)}
                    style={{ width: '100%' }}
                />
            </Stack>
        </Stack>
    );
};

export default ReportDateRangeFilter;